import React, { Component, createRef } from 'react'

export interface Props {
  minHeight: number
  maxHeight: number
  value: string
}

class GrowingTextarea extends Component<Props> {
  static displayName = 'GrowingTextarea'

  state = {
    height: 0,
  }

  componentDidMount() {
    this.setHeight()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setHeight()
    }
  }

  private textarea = createRef<HTMLTextAreaElement>()

  setHeight() {
    // We have to set the height to 0 first so the scrollHeight returns the minimum necessary value
    this.setState(
      () => ({ height: 0 }),
      () => {
        const { minHeight, maxHeight } = this.props
        const textarea = this.textarea.current

        let scrollHeight = 0
        if (textarea) {
          let { scrollHeight } = textarea
          textarea.scrollTop = scrollHeight
        }

        if (minHeight) {
          scrollHeight = Math.max(scrollHeight, minHeight)
        }

        if (maxHeight) {
          scrollHeight = Math.min(scrollHeight, maxHeight)
        }

        if (this.state.height !== scrollHeight) {
          this.setState({ height: scrollHeight })
        }
      }
    )
  }

  render() {
    // eslint-disable-next-line
    const { minHeight, ...props } = this.props
    const { height } = this.state

    return <textarea ref={this.textarea} style={{ height }} {...props} />
  }
}

export default GrowingTextarea
